import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { submitMeasurement } from '../services/measurementService';
import type { MeasurementPayload, MeasurementResponse } from '../services/measurementService';

export interface UseSubmitMeasurementOptions {
  /** Replaces the default POST /measurements call (e.g. record-and-link to a journal entry). */
  submit?: (payload: MeasurementPayload) => Promise<MeasurementResponse>;
  onSuccess?: (data: MeasurementResponse) => void;
  onError?: (error: Error) => void;
}

export function useSubmitMeasurement(
  options?: UseSubmitMeasurementOptions,
): UseMutationResult<MeasurementResponse, Error, MeasurementPayload> {
  const queryClient = useQueryClient();

  return useMutation<MeasurementResponse, Error, MeasurementPayload>({
    mutationFn: (payload: MeasurementPayload) => (options?.submit ?? submitMeasurement)(payload),
    onSuccess: (data: MeasurementResponse) => {
      void queryClient.invalidateQueries({ queryKey: ['measurements'] });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      options?.onError?.(error);
    },
  });
}
